import { createContext, useContext, useState, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [userId, setUserId] = useState(null);

  const [permissions, setPermissions] = useState({});
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(true);

  const apiUrl = process.env.REACT_APP_API_URL;

  useLayoutEffect(() => updateToken(), []);

  const updateToken = () => {
    const savedToken = localStorage.getItem("token");

    if (!savedToken) {
      setLoading(false);
      return;
    }
    setToken(savedToken);
    const decoded = jwtDecode(savedToken);

    setUserId(decoded.user_id);
    let userID = decoded.user_id;

    axios
      .get(`${apiUrl}/users/${userID}`, {
        headers: { Authorization: `Bearer ${savedToken}` },
      })
      .then((res) => {
        const data = res.data.data;

        setUserData(data);
        setPermissions(data.user_profile.permissions || "{}");
      })
      .catch(() => {
        localStorage.removeItem("token");
        window.location.reload();
      })
      .finally(() => setLoading(false));
  };

  const hasPermission = (module, action) => {
    if (!module) return true;

    if (module !== "logs") {
      return permissions?.[module]?.[action]?.toString().charAt(0) === "1";
    }
    return permissions?.[module]?.toString().charAt(0) === "1";
  };

  return (
    <TokenContext.Provider
      value={{
        token,
        userId,
        permissions,
        userData,
        updateToken,
        hasPermission,
        loading,
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};

TokenProvider.propTypes = {
  children: PropTypes.object.isRequired,
};
export const useToken = () => useContext(TokenContext);
